import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./Filter.scss";
import Discounts from "./components/Discounts";
import FilterContainer from "./components/FilterContainer";
import Rooms from "./components/Rooms";
import Aminities from "./components/Aminities";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import useToggle from "hooks/useToggle";
import Sort from "./Sort";
import { useAppDispatch, useAppSelector } from "store/store";
import { searchSelector, activeFilters, activeMobFilters } from "features/search-property/searchproperty.slice";
import useWindowSize from "hooks/useWindowSize";
import { clearSearchResult } from "features/search-result/searchresult.slice";
import icondown from "assets/icons/search/icon-down.svg";
import useClickOutside from "hooks/useClickOutside";
import { DirectionCheck } from "../../../../utils/classnameSwitch";
import { FILTER_CONFIG } from "./search-filter.config";

interface IFilter { amenities: [], setOpen?: React.Dispatch<React.SetStateAction<boolean>> }
const Filter: React.FC<IFilter> = ({ amenities, setOpen }) => {
    const {t} = useTranslation();
 
    const dispatch = useAppDispatch();
    const { filters, mobFilters } = useAppSelector(searchSelector);
    const maxnode = React.useRef<HTMLDivElement>(null);
    const minnode = React.useRef<HTMLDivElement>(null);
    const [priceRange, setPrice] = useState(FILTER_CONFIG.DEFAULT_MIN_MAX);
    const [minVisible, toggleMinVisible] = useToggle();
    const [maxVisible, toggleMaxVisible] = useToggle();
    const [priceToggle, togglePrice] = useToggle();
    const size: any = useWindowSize();
    const updatePriceRange = (price: any) => {
        if (size.width ? size.width > 1110 : false) {
            let params = { ...filters };
            params['price'] = price[0] + '-' + price[1];
            dispatch(clearSearchResult());
            dispatch(activeFilters(params));
        }
        else {
            let params = { ...mobFilters };
            params['price'] = price[0] + '-' + price[1];
            dispatch(activeMobFilters(params));
        }
    }
    useClickOutside(minnode, () => {
        if (minVisible) toggleMinVisible();
    })
    useClickOutside(maxnode, () => {
        if (maxVisible) toggleMaxVisible();
    })
    const resetFilter = () => {
        // eslint-disable-next-line
        const params = Object.entries(filters).filter((item) => {
            if (item[0] === "longitude" || item[0] === "latitude" || item[0] === "from"
                || item[0] === "to" || item[0] === "guests") { return item }
        })
            .reduce((accum: any, [k, v]) => {
                accum[k] = v;
                return accum;
            }, {});
        const inputs: any = document.querySelector(".refine")?.getElementsByTagName('input');
        for (let index = 0; index < inputs.length; ++index) {
            inputs[index].checked = false
        }
        if (size.width < 1110) {
            Array.from(document.querySelectorAll('.radio-label')).forEach((el) => {
                el.classList.remove('radio_label_is_checked');
                el.classList.remove('radio_d_label_is_checked');
            });
            Array.from(document.querySelectorAll('.refine input')).forEach((el: any) => el.checked = false);
            dispatch(activeMobFilters(params));
            if (setOpen) { setOpen(false) };
        }
        dispatch(clearSearchResult());
        dispatch(activeFilters(params));
        setPrice(FILTER_CONFIG.DEFAULT_MIN_MAX);
    }

    const generateSliderMark = (text: string, marginLeft: "25px" | "-41px") => <span style={{ marginLeft: marginLeft }}>{text.trim() ? text : ""}</span>; 

    const marks = {
        100: {
            label: generateSliderMark("AED 100", "25px"),
        },
        1100: {
            label: generateSliderMark("", "25px"),
        },
        2100: {
            label:  generateSliderMark("", "25px"),
        },
        3100: {
            label:  generateSliderMark("", "25px"),
        },
        4100: {
            label:  generateSliderMark("", "25px"),
        },
        5000: {
            label:  generateSliderMark("AED 5000+", "-41px"),
        },
    };

    // Values to be populated in the dropdown on either sides of the price slider
    const sliderDropdownValues = [100, ...Array.from({length: 15}, (_, i) => 200 + (i * 200)), ...Array.from({length: 4}, (_, i) =>  3500 + (i * 500))];

    return (
        <>
            <div dir={DirectionCheck()}>
                <ul className="refine">
                    <li> <div className="mobile-filter-header">
                    {t("searchResults.filter")}
                        <span>
                            {size.width < 1110 && <span className={`reset-filter clear-filter ${DirectionCheck() === "rtl" ? "ml-4": ""}`} onClick={() => { if (setOpen) setOpen(false) }}>{t(`searchResults.close`)}</span>}
                            <span className="reset-filter" onClick={resetFilter}>{t("searchResults.reset")}</span></span>
                    </div></li>
                    <Sort></Sort>
                    <li className="refine__section">
                        <div className="refine__heading" onClick={togglePrice}>
                            <div className="refine__heading-content">{t("searchResults.price")}</div>
                            <img src={icondown} className={`chevron ${priceToggle ? 'open' : 'close'}`} alt="chevron"></img>
                        </div>

                        <div className={`refine__content ${priceToggle ? 'collapsed' : ''}`} dir='ltr'>
                            <div
                                style={{
                                    marginTop: "30px",
                                    marginBottom: "30px",
                                    marginLeft: "20px",
                                    marginRight: "20px",
                                }}
                            >
                                <Slider.Range
                                    min={FILTER_CONFIG.FILTER_MIN}
                                    max={FILTER_CONFIG.FILTER_MAX}
                                    marks={marks}
                                    step={FILTER_CONFIG.STEP_COUNT}
                                    included={true}
                                    defaultValue={FILTER_CONFIG.DEFAULT_MIN_MAX}
                                    value={priceRange}
                                    allowCross={false}
                                    onChange={(value) => {
                                        if (value[0] !== value[1]) {
                                            setPrice(value);
                                            updatePriceRange(value);
                                        }
                                    }}
                                />
                            </div>
                            <div className="slider-alter-dropdown">
                                <div className="dropdown is-active">
                                    <div className="dropdown-trigger" >
                                        <div
                                            className="button"
                                            onClick={() => {
                                                toggleMinVisible();
                                                if (maxVisible) {
                                                    toggleMaxVisible();
                                                }
                                            }}
                                        >
                                            <span>AED {priceRange[0]}</span>
                                            <span className="icon is-small">
                                                <i className="fas fa-angle-down" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </div>
                                    {minVisible && (
                                        <div className="dropdown-menu slider-values" id="dropdown-menu" role="menu" ref={minnode}>
                                            <div className="dropdown-content scrollbar">
                                                {sliderDropdownValues.map((item, index) => (
                                                    item !== 2000 &&
                                                    <>
                                                        <div key={`min${index}`} className={`${item === priceRange[0] ? 'selected-price' : ''}`} onClick={() => {
                                                            let price: any = [];
                                                            if (item < priceRange[1]) {
                                                                price = [item, priceRange[1]];
                                                                setPrice(price);
                                                            };
                                                            if (item >= priceRange[1] && item !== 2000) {
                                                                price = [item, item + 200];
                                                                setPrice([item, item + 200])
                                                            };
                                                            toggleMinVisible();
                                                            updatePriceRange(price);
                                                        }}>AED {item}</div>
                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <span className="to">To</span>
                                <div className="dropdown is-active">
                                    <div className="dropdown-trigger">
                                        <div className="button"
                                            onClick={() => {
                                                toggleMaxVisible();
                                                if (minVisible) {
                                                    toggleMinVisible();
                                                }
                                            }}
                                        >
                                            <span>AED {priceRange[1]}</span>
                                            <span className="icon is-small">
                                                <i className="fas fa-angle-down" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </div>
                                    {maxVisible && (
                                        <div
                                            className="dropdown-menu slider-values"
                                            id="dropdown-menu"
                                            role="menu"
                                            ref={maxnode}
                                        >
                                            <div className="dropdown-content scrollbar" id="style-5">
                                                {/* <div className="scrollbar" id="style-9"> */}
                                                {sliderDropdownValues.map((item, index) => (
                                                    <div key={`min${index}`} className={`${item <= priceRange[0] ? 'disabled-dd' : ''} ${item === priceRange[1] ? 'selected-price' : ''}`} onClick={() => {
                                                        setPrice([priceRange[0], item]);
                                                        toggleMaxVisible();
                                                        const price = [priceRange[0], item];
                                                        updatePriceRange(price);
                                                    }}>AED {item}{index === sliderDropdownValues.length - 1 ? "+" : ""}</div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </li>
                    <FilterContainer title={t("searchResults.discnt")}>
                        <Discounts></Discounts>
                    </FilterContainer>
                    <FilterContainer title={t("searchResults.rooms")}>
                        <Rooms></Rooms>
                    </FilterContainer>
                    <FilterContainer title={t("searchResults.amnty")}>
                        <Aminities amenities={amenities}></Aminities>
                    </FilterContainer>
                </ul>
            </div>
        </>
    );
};

export default Filter;
